<template>
  <!-- LIVE VIDEO -->
  <BaseModal :title="'Live Video Unidad: ' + getUnitNameById(unit_id)" modalId="liveVideo" :isVisible="true" @close="closeDialog">
    <div id="buscador" class="form">
      <div class="container-fluid">
        <div class="row row-h-100">
          <div class="vid-container">
            <button
              @click="changeVideo('/fserver/hls/' + unit_id + '/index.m3u8')"
              class="btn btn-sm btn-primary reload-button"
              title="Recargar"
            >
              <i class="bi bi-arrow-clockwise text-white"></i>
            </button>
            <video-player
              v-if="reRenderPlayer"
              class="video-player vjs-theme-forest"
              :options="videoOptions"
            />
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
  <!-- FIN LIVE VIDEO -->
</template>
<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue'
import VideoPlayer from './VideoPlayer.vue'
import BaseModal from './base/BaseModal.vue'
import 'video.js/dist/video-js.css'
import { useBrowserDetect } from 'vue3-detect-browser'
import { useServicesStore } from '@/stores/services'
import { storeToRefs } from 'pinia'

const emit = defineEmits<{
  (event: 'closed'): void
}>()
function closeDialog() {
  emit('closed')
}

const { isSafari } = useBrowserDetect()

const props = defineProps<{
  unit_id?: string | null
}>()

const unit_id = ref(props.unit_id ?? null)
const serv = useServicesStore()

const { unitsOnline } = storeToRefs(serv)
// console.log('isSafari:' + isSafari)

const videoOptions = reactive({
  //techOrder: ["flash","html5"],
  autoplay: true,
  controls: true,
  fluid: true,
  preload: 'auto',
  html5: {
    vhs: {
      overrideNative: !isSafari,
      bandwidth: 5039
    },
    nativeAudioTracks: false,
    nativeVideoTracks: false
  },
  sources: [
    {
      src: '/fserver/hls/' + unit_id.value + '/index.m3u8',
      type: 'application/x-mpegURL'
      //type: 'video/mp4',
    }
  ],
  width: 500,
  height: 300,
})
function getUnitNameById(unit_id: string | null | undefined): string {
  if (!unit_id) return ''

  const unit = unitsOnline.value?.find((u) => u.unit_id === unit_id)
  return unit?.name ?? ''
}
const reRenderPlayer = ref(false)
onMounted(async () => {
  //changeVideo('rtmp://192.168.75.54:8244/live/TST1')
  await changeVideo('/fserver/hls/' + unit_id.value + '/index.m3u8')
})

async function changeVideo(file_name: string) {
  reRenderPlayer.value = false

  console.log('archivo ', file_name)

  videoOptions.sources[0].src = file_name
  await new Promise((resolve) => setTimeout(resolve, 500))
  reRenderPlayer.value = !reRenderPlayer.value
}
</script>
<style lang="css" scoped>
.form,
.container-fluid {
  height: 100%;
}

.vid-container {
  position: relative;
  min-width: 300px;
  min-height: 160px;
  border: 1px solid rgba(223, 223, 223, 0.3);
  border-radius: 5px;
  margin-bottom: 15px;
  width: fit-content;
  aspect-ratio: 16 / 9;
  align-content: center;
  height: 100%;
}

.modal-container {
  min-width: 536px;
  width: 470px;
  height: 530px;
}

.row {
  padding-right: 0%;
  justify-content: space-evenly;
}

.row-h-100 {
  height: calc(100% - 40px);
  margin: 5px 5px 5px 5px;
}

.justify-content-right {
  display: flex;
  justify-content: right;
  height: min-content;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.top-0 {
  top: 0 !important;
}

.end-0 {
  right: 0 !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}

.btn-light:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}

.bi-arrow-clockwise {
  font-size: 1rem;
}

.reload-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 576px) {
  .modal-container-small {
    max-width: 90vw;
    min-width: 315px;
    width: 90vw;
    height: 480px;
    min-height: 300px;
    left: 20px;
  }
}
</style>
